import React from "react";
import { FaPhone } from "react-icons/fa";
import Link from 'hooks/Link';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const CallToAction = () => {
  const {t} = useTranslation();

  const { user} = useSelector((store) => store.user);

  return (
    <>
      <div className="join-banner" style={{marginTop : user?.isVerified && user?.profileCompleted > 0 ?  "96px" : "72px"}}>
        <p>
          
          {t("descs.financial_message")}
        </p>
        <a
          href="tel:+52 871 116 1608"
          className="lp-btn fill square text-center"
        >
          <FaPhone />
        </a>
      </div>
    </>
  );
};

export default CallToAction;
